import { getClassPerson } from "@/services/class-person.service";

// initial state
const state = () => ({});

// mutations
const mutations = {};

// actions
const actions = {
  async loadClassPerson(vuexContext, co) {
    return await getClassPerson(co).then((response) => {
      let data = response.data.data;
      let items = data.items;
      items.map((item, index) => {
        item.index = index + 1;
        item.value = item.id;
        item.label = item.name;
        item.startUrlEmbed = process.env.VUE_APP_CDN + "cevrimici-toplanti?mn=" + item.start_url?.split("/s/");
        item.zak = item.start_url?.split("zak=")[1];
        item.meetingNumber = item.start_url?.split("?")[0].split("/s/")[1];
      });
      return items;
    });
  },
};

// getters
const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
